module.exports = __webpack_public_path__ + "img/info-help.2db843ed.svg";